// ./src/utils/offeringOrder.ts
//
// The order partner offerings are shown in — on the host's screens AND the public "Become a partner" block. Pure and
// type-only in its imports, so `check-event-setup` runs it.

import type { EventPartnerPackage } from './api/EventPartnerPackageService';

/**
 * THE ORDER SPONSORS SEE on the "Become a partner" block — the public read's own sort (PublicEventCore
 * `loadPartnerOfferings`): `orderNo`, then the per-event price, highest first (an empty price counts as 0). The host's
 * lists sort the SAME way, or a host who never dragged sees one order and sponsors another (review, 2026-10-01: every
 * offering starts on the same default `orderNo`, so the tie-break IS the order until somebody drags).
 */
export const byOfferingDisplayOrder = (a: EventPartnerPackage, b: EventPartnerPackage): number =>
  (Number(a.orderNo ?? 0) || 0) - (Number(b.orderNo ?? 0) || 0) || (Number(b.amount ?? 0) || 0) - (Number(a.amount ?? 0) || 0);
